import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { User } from 'src/app/shared/models/user.model';
import { EventsService } from 'src/app/shared/services/events.service';
import { environment } from 'src/environments/environment';
import { Store } from '../store/store';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  url = environment.apiBaseUrl;
  
  constructor(private router: Router, private http: HttpClient, private store: Store, private eventsService: EventsService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if(route.queryParams && route.queryParams.accessToken) {
      if(localStorage.getItem('token')) {
        localStorage.removeItem('token');
      }
      localStorage.setItem("token", route.queryParams.accessToken); 
      // capture event
      localStorage.setItem("eventCapture", 'true');
      localStorage.setItem('role', 'LEARNER');
    }
    if (this.isLoggedIn() ) {
      if((localStorage.getItem('role') == 'ADMIN') || (localStorage.getItem('role') == 'PARTNER_ADMIN')) {
        this.router.navigate(['/learning-insights']);;
      }
      this.setUserData();
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  isLoggedIn() {
    return localStorage.getItem('token') ? true : false;
  }

  setUserData() {
    this.http.get<{ data: User, result: number, msg: string }>(`${this.url}users/self`).subscribe(
      res => {
        this.store.set('user', res.data);
        try {
          if(localStorage.getItem('eventCapture') && (res && res.data)){
            localStorage.removeItem('eventCapture')
            this.eventsService.loginEvent(res.data);
          }
        } catch (err) {
          console.log(err);  
        }
      },
      err => {
        console.log(err);
        this.store.set('user', null)
      }
    )
  }

}
